const adminRoles = {
  manageAdmin: "manage:v2admin",
};

export const rbac = {
  ...adminRoles,
};
